// extracted by mini-css-extract-plugin
export default {"main":"richtext_main__n3hTe"};